<template>
    <ui-container class="space-y-8 py-8" v-if="nonConformanceReport">
        <!-- Header. -->
        <ui-header :title="`Non-Conformance Report #${nonConformanceReport.reference}`"
                   :subtitle="nonConformanceReport.status">
            <template #actions>
                <ui-button-new icon="fas fa-arrow-left"
                               @click="edit(false)">
                    Done
                </ui-button-new>
            </template>
        </ui-header>

        <ui-input class="col-span-12" label="Title" name="title" placeholder="Title of NCR..."
                  @input="updateItem();saveIt()"
                  @change="updateItem();saveIt()"
                  v-model="nonConformanceReport.title"></ui-input>
        <ui-input-file-inline label="Image and Videos"
                              name="media[]"
                              :filesystemId="nonConformanceReport.inlineFilesystemId"
                              :readonly="false"
                              :attachUrl="attachUrl"
                              :detachUrl="detachUrl"
                              :downloadUrl="downloadUrl"
                              :current-files="getNonConformanceReportFiles"></ui-input-file-inline>
        <ui-date-picker label="Date" name="date" v-model="nonConformanceReport.date"
                        class="xl:col-span-6"
                        @input="updateItem();saveIt()"
                        @change="updateItem();saveIt()"
                        placeholder="What is date for NCR?"
                        :with-time="false"
        ></ui-date-picker>
        <ui-input class="xl:col-span-6" label="Contract Reference" name="contract_ref"
                  @input="updateItem();saveIt()"
                  @change="updateItem();saveIt()"
                  placeholder="Contract reference..."
                  v-model="nonConformanceReport.contractReference"></ui-input>
        <ui-input label="Location of Works" name="location_of_works"
                  @input="updateItem();saveIt()"
                  @change="updateItem();saveIt()"
                  placeholder="Roof, Above door way, etc..."
                  v-model="nonConformanceReport.locationOfWorks"></ui-input>
        <ui-textarea label="Site Address" name="site_address" placeholder="Address of Site..."
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.siteAddress"></ui-textarea>
        <ui-textarea label="What is the main reason or what when wrong?" name="reasoning"
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.whatWentWrong"></ui-textarea>
        <ui-textarea label="Why doesn't the work meet specs?" name="why"
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.whyNotMeetingSpec"></ui-textarea>
        <ui-textarea label="What can be done to prevent it from happening again?" name="prevention"
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.whatToPrevent"></ui-textarea>
        <ui-textarea label="Explanatory corrective action taken." name="corrective"
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.correctiveActionTaken"></ui-textarea>
        <ui-textarea label="Key players involved in the NCR and specs affected under the NCR." name="players"
                     @input="updateItem();saveIt()"
                     @change="updateItem();saveIt()"
                     v-model="nonConformanceReport.keyPlayers"></ui-textarea>
    </ui-container>
</template>

<script>
import {NonConformanceReport} from '@models'
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiInputFileInline from "../../filesystem/inline/UiInputFileInline.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiInput from "../../ui/UiInput.vue";
import UiTextarea from "../../ui/UiTextarea.vue";
import UiContainer from "../../ui/UiContainer.vue";
import UiHeader from "../../ui/UiHeader.vue";
import {debounce} from "lodash";
import moment from "moment";

export default {
    components: {UiHeader, UiContainer, UiTextarea, UiInput, UiButtonNew, UiInputFileInline, UiDatePicker},
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
        removeItem: Function,
        packageReference: Number,
        packageName: null,
    },
    data() {
        return {
            nonConformanceReport: null,
            saveIt: debounce(this.save, 400, {leading: true, maxWait: 3000}),
        }
    },
    computed: {
        editMode() {
            return !!this.item
        },
    },
    methods: {
        async updateItem() {
            this.item.title = this.nonConformanceReport.title;
            this.item.date = this.nonConformanceReport.date;
            this.item.formattedDate = moment(this.nonConformanceReport.date).format('DD/MM/YYYY');
        },
        async save() {
            this.busy = true;
            await this.nonConformanceReport.update()
            this.busy = false
        },
        attachUrl(id) {
            return route('api.v2.hsqe.non-conformance-reports.file.attach', {
                'id': this.nonConformanceReport.id,
                'package_reference': this.nonConformanceReport.packageReference,
                'file_id': id
            })
        },
        detachUrl(id) {
            return route('api.v2.hsqe.non-conformance-reports.file.detach', {
                'id': this.nonConformanceReport.id,
                'package_reference': this.nonConformanceReport.packageReference,
                'file_id': id
            })
        },
        downloadUrl(id) {
            return route('api.v2.hsqe.non-conformance-reports.file.download', {
                'id': this.nonConformanceReport.id,
                'package_reference': this.nonConformanceReport.packageReference,
                'file_id': id
            })
        },
        async getNonConformanceReportFiles() {
            let data = await NonConformanceReport.find(this.nonConformanceReport.packageReference, this.nonConformanceReport.id)
            return data.files
        },

    },
    async mounted() {
        if (this.item) {
            this.nonConformanceReport = await NonConformanceReport.find(this.item.packageReference, this.item.id);
        }
    }
}
</script>
